import React from "react";
import styled from "styled-components";
import MarkerStore from "../../../../stores/marker-store";
import EmojiButton from "./emoji-button";
import { getAllReactions } from "./helpers";
import { cloud } from "@vitalsource/vstui/colors";

const EmojisContainer = styled.div.attrs({
  "data-testid": "emoji-reactions"
})`
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-weight: 400;
  border-top: 1px solid ${cloud.getShade(4)};
  padding: 3px 6px;
  height: 45px;
  /* Need font-family for colored Emojis in IE 11 */
  font-family: Segoe UI Emoji, sans-serif;
`;

const EmojiReactions = ({ currentEmoji, emojiClick }) => {
  if (
    Fraction.Helpers.isLabEnabled("emoji-reactions") &&
    MarkerStore.getAll().markers.length
  ) {
    return (
      <EmojisContainer aria-label={i18n.t("emoji-reactions.title")}>
        {getAllReactions().map(emoji => (
          <EmojiButton
            key={emoji.label}
            selected={currentEmoji === emoji.unicode}
            emoji={emoji}
            onClick={() =>
              emojiClick(emoji.unicode, currentEmoji === emoji.unicode)
            }
          />
        ))}
      </EmojisContainer>
    );
  }
  return null;
};

export default EmojiReactions;
